import { Uri } from './uriAdapter.js';

import {
    getURLParam as innerGetURLParam,
    getURLParams as innerGetURLParams,
    sortQueryParams as innerSortQueryParams,
    removeUTMParams as innerRemoveUTMParams,
} from './dupes/queryParams.js';


// queryParams _impl_ cannot depend on real Uri; slap it on window here?
window.Uri = window.Uri || Uri;

export const getURLParam = innerGetURLParam;
export const getURLParams = innerGetURLParams;
export const sortQueryParams = innerSortQueryParams;
export const removeUTMParams = innerRemoveUTMParams;
